export default "__VITE_ASSET__e8b5dff8__"